export const useDecodedKeyword = (keyword: string | string[] | undefined) => {
  if (!keyword) return undefined

  const keywordStr = Array.isArray(keyword) ? keyword[0] : keyword

  if (!keywordStr) return undefined

  try {
    return decodeURIComponent(keywordStr)
  } catch {
    return keywordStr
  }
}
